
import { Component, Prop, Vue } from "vue-property-decorator";
import httpClient from "@/store/httpClient";
import { CustomerAuditTrailDto } from "@/dtos/customerAuditTrailDto";
import { EventType } from "@/dtos/eventType";
import { ArticleState } from "@/dtos/articleState";

@Component({
	components: {},
})
export default class AuditTrail extends Vue {
	@Prop()
	private customerId!: number;
	private auditsLoading: boolean = true;
	private audits: CustomerAuditTrailDto[] = new Array<CustomerAuditTrailDto>();
	private articleCreateEvent: number = EventType.ArticleCreated;
	private articleDeleteEvent: number = EventType.ArticleDeleted;
	private calculateOrderEvent: number = EventType.CalculatedOrder;
	private articleValidatedEvent: number = EventType.ArticleValidated;

	private mounted() {
		this.loadAudits();
	}

	private getIcon(eventType: EventType) {
		switch (eventType) {
			case EventType.ArticleCreated:
			case EventType.ArticleValidated:
				return "extension";
			case EventType.ArticleDeleted:
				return "delete_forever";
			case EventType.CalculatedOrder:
				return "calculate";
			default:
				return "question";
		}
	}

	private getHeadline(audit: CustomerAuditTrailDto) {
		switch (audit.eventType) {
			case EventType.ArticleCreated:
				return `Erstellt Artikel ${audit.articleId}`;
			case EventType.ArticleDeleted:
				return `Löschung Artikel ${audit.articleId}`;
			case EventType.ArticleValidated:
				return `Validierung Artikel ${audit.articleId}`;
			case EventType.CalculatedOrder:
				return `Calculation ${audit.calculationId}`;
			default:
				return "Unbekannter Event";
		}
	}

	private getArticleStateText(state: ArticleState) {
		switch (state) {
			case ArticleState.OK:
				return "OK";
			case ArticleState.Warning:
				return "Warning";
			case ArticleState.Error:
				return "Error";
			case ArticleState.Locked:
				return "Locked";
			case ArticleState.New:
				return "New";
			case ArticleState.Open:
				return "Open";
			case ArticleState.Info:
				return "Info";
			case ArticleState.Deleted:
				return "Deleted";
		}
	}

	private async loadAudits() {
		try {
			this.auditsLoading = true;
			const response = await httpClient().get(
				`Report/GetCustomerAuditTrail?customerId=${this.customerId}`
			);
			this.audits = response.data;
		} catch {
			this.$store.commit("setSnackbarErrorText", "Fehler beim Laden des Audit Trails.");
		} finally {
			this.auditsLoading = false;
		}
	}
}
